import { render, staticRenderFns } from "./GLCodeSetup.vue?vue&type=template&id=6d4db340"
import script from "./GLCodeSetup.vue?vue&type=script&lang=js"
export * from "./GLCodeSetup.vue?vue&type=script&lang=js"
import style0 from "./GLCodeSetup.vue?vue&type=style&index=0&id=6d4db340&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports